import { ReCaptchaSetting } from 'backend';

const RE_CAPTCHA_SRC_BASE = 'https://www.google.com/recaptcha/api.js?render=';
export const getReCaptchaScriptSrc = (
  siteKey: ReCaptchaSetting['siteKey'],
): string => `${RE_CAPTCHA_SRC_BASE}${siteKey}`;

export const RE_CAPTCHA_SCRIPT_ID = 'synergy-nform-reCaptcha-script';

export const RE_CAPTCHA_BADGE_CSS_SELECTOR = '.grecaptcha-badge';

export const getReCaptchaBadgeElement = (): HTMLDivElement | null =>
  document.querySelector(RE_CAPTCHA_BADGE_CSS_SELECTOR);

export const getReCaptchaScriptElement = (): HTMLScriptElement | null =>
  document.getElementById(RE_CAPTCHA_SCRIPT_ID) as HTMLScriptElement | null;
